import React from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ClientSideConfigSelector from '../../recoil/cashout/ClientSideConfigSelector';
import Convert from '../icons/Convert';
import { capitalize } from '../helpers/SubscriptionsUtil';

export default function ConvertLink() {
  const { t } = useTranslation(null, { useSuspense: false });

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        appCurrency,
      } = {},
    },
  } = config;

  return (
    <Link to="/convert" className="diamonds-conversion-to-credits">
      <Convert />
      <span>{t('index_convert_diamonds_to___appcurrency__', { appCurrency: capitalize(t(appCurrency?.toLowerCase())) })}</span>
      <span className="diamonds-conversion-caret">
        <svg>
          <use
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref="img/icons/economy.svg?1510677573844#ic_caret_right"
          />
        </svg>
      </span>
    </Link>
  );
}
